import { responsiveFontSizes } from 'utils/getFontValue';

// ----------------------------------------------------------------------

const typography = {
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 80 / 64,
    letterSpacing: 2,
    ...responsiveFontSizes({ sm: 16, md: 58, lg: 64 })
  },
  h2: {
    fontWeight: 700,
    lineHeight: 64 / 48,
    ...responsiveFontSizes({ sm: 16, md: 44, lg: 48 })
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 16, md: 30, lg: 32 })
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.5,

    ...responsiveFontSizes({ sm: 16, md: 24, lg: 24 })
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 16, md: 20, lg: 20 })
  },
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 16,
    ...responsiveFontSizes({ sm: 15, md: 17, lg: 17 })
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 13, md: 15, lg: 16 })
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    ...responsiveFontSizes({ sm: 9, md: 12, lg: 13 })
  },
  body1: {
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 12, md: 13, lg: 14 })

  },
  body2: {
    lineHeight: 22 / 14,
    ...responsiveFontSizes({ sm: 12, md: 13, lg: 14 })

  },
  caption: {
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 10, md: 12, lg: 12 })
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 10, md: 12, lg: 12 }),

    textTransform: 'uppercase'
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    ...responsiveFontSizes({ sm: 10, md: 14, lg: 14 }),
    textTransform: 'capitalize'
  }
};

export default typography;
